import { render } from "./VideoGrid.vue?vue&type=template&id=de5c6d82&scoped=true"
import script from "./VideoGrid.vue?vue&type=script&lang=js"
export * from "./VideoGrid.vue?vue&type=script&lang=js"

import "./VideoGrid.vue?vue&type=style&index=0&id=de5c6d82&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5c6d82"]])

export default __exports__